/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DtoAccountInfoBaseResponse as ModelsAccountDtoAccountInfoBaseResponse } from '../../models/Models/Account/dto-account-info-base-response';

export interface V3AccountsEntityIdInfoGet$Xml$Params {
  entityId: string;
}

export function v3AccountsEntityIdInfoGet$Xml(http: HttpClient, rootUrl: string, params: V3AccountsEntityIdInfoGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>> {
  const rb = new RequestBuilder(rootUrl, v3AccountsEntityIdInfoGet$Xml.PATH, 'get');
  if (params) {
    rb.path('entityId', params.entityId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ModelsAccountDtoAccountInfoBaseResponse>;
    })
  );
}

v3AccountsEntityIdInfoGet$Xml.PATH = '/v3/accounts/{entityId}/info';
